import React from 'react';
import AutoRajaPageNav from './AutoRajaPageNav';
import AttributionsRenderer from './AttributionsRenderer';
import attributionsData from '../data/autorajaAttributions.json';

const AutoRajaCredits = ({ navigateToPath }) => (
  <main className="content">
    <section className="section autoraja-legal-page">
      <div className="container">
        <AutoRajaPageNav route="autoraja-credits" navigateToPath={navigateToPath} />
        <header className="legal-heading">
          <p className="section-kicker">AutoRaja</p>
          <h1>Credits &amp; Licenses</h1>
        </header>
        <p className="credits-intro">
          {attributionsData.intro ||
            'Third-party assets and software used in AutoRaja are credited here.'}
        </p>
        <AttributionsRenderer data={attributionsData} />
      </div>
    </section>
  </main>
);

export default AutoRajaCredits;
